import React from "react";
import { Link } from "react-router-dom";
import { Stars } from "./Stars";

export const Book = ({ book }) => {
  return (
    <div
      data-carousel-item
      className="card w-full min-w-[300px] max-w-xs h-[500px] rounded-lg bg-white border mb-12 "
    >
      <Link to={`/books/${book.id}`}>
        {book?.imageUrl[0] ? (
          <img
            className="h-60 w-full object-contain bg-gray-100 rounded-t-lg"
            src={book?.imageUrl[0].downloadURL}
            alt={book?.imageUrl[0].name}
          />
        ) : (
          <p className="bg-gray-300 h-60 rounded-t-lg text-center pt-5 flex justify-center items-center">
            <svg
              className="w-12 h-12 text-gray-200"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 640 512"
            >
              <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
            </svg>
          </p>
        )}

        <div className="p-6">
          <h4 className="mb-1 text-xl font-bold leading-tight text-neutral-800 h-12">
            {book.title}
          </h4>
          <p className="mb-3 text-xl text-gray-600">{book.author}</p>
          <p className="mb-3 text-base text-gray-600 h-20 min-h-max">
            {book.small_description}
          </p>
          <div className="flex justify-between">
            <Stars reviewScore={book.review_score} classes="w-5 h-5" />
            <span>{book.review_score}</span>
          </div>
        </div>
      </Link>
    </div>
  );
};
